module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_3.34e688aa.png";